/**
 * Frontend runtime config — sourced from Vite env variables (`VITE_…`).
 * The TG Mini App is served from `https://durakapp.nexaweb.su`, so by default the
 * API and the socket transport live on the same origin. Override via env in dev.
 */
const env = import.meta.env;

export const config = {
  apiBaseUrl: (env['VITE_API_BASE_URL'] as string | undefined) ?? '/api',
  socketUrl: (env['VITE_SOCKET_URL'] as string | undefined) ?? '',
  socketPath: (env['VITE_SOCKET_PATH'] as string | undefined) ?? '/socket.io',
  isDev: env.DEV === true,
} as const;

export type Config = typeof config;
